/**
 * A URL taken from a REACT_APP_* variable, made safe to build paths on.
 *
 * These values are typed by hand into three different places — the deploy
 * workflows' Variables, the prod workflow's literals, and the `start-*` npm
 * scripts — and they do not agree about trailing slashes. The code that
 * consumes them appends paths (`${hostedUi}/logout`), so a trailing slash in
 * the variable became a double slash in the request. Cognito's hosted UI
 * tolerates `//oauth2/authorize` but answers `//logout` with a 403
 * "Missing Authentication Token" — sign-in worked and sign-out did not, and
 * nothing in the code hinted that a deploy variable was the difference
 * (SW-7019). Every URL variable now passes through here, once, at module load.
 */
export function urlFromEnv(value: string | undefined): string | undefined {
  if (value === undefined) return undefined;
  const trimmed = value.trim().replace(/\/+$/, "");
  return trimmed === "" ? undefined : trimmed;
}
